// Configurations partagees du tableau de bord de crise
export const severityColors = {
    critique: '#ef4444',
    modere: '#f59e0b',
    faible: '#22c55e'
};

export const vehicleStatusColors = {
    disponible: '#22c55e',
    en_mission: '#f59e0b',
    en_transit: '#3b82f6',
    maintenance: '#f97316',
    en_panne: '#ef4444',
    reapprovisionnement: '#a855f7'
};

export const vehicleStatusLabels = {
    disponible: 'Disponible',
    en_mission: 'En mission',
    en_transit: 'En transit',
    maintenance: 'Maintenance',
    en_panne: 'En panne',
    reapprovisionnement: 'Reappro.'
};
